import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import { ReactComponent as LockIcon } from '../../../assets/images/lock.svg';

interface LockUserDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason?: string) => void;
  userName: string;
  loading?: boolean;
}

export const LockUserDialog = ({
  open,
  onClose,
  onConfirm,
  userName,
  loading = false,
}: LockUserDialogProps) => {
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    onConfirm(reason.trim() || undefined);
    setReason('');
  };

  const handleClose = () => {
    if (loading) return;
    setReason('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <LockIcon width={24} height={24} style={{ color: '#c62828' }} />
          <Typography variant="h6" fontFamily="GilroySemiBold">
            Lock User Account
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Lock account for <strong>{userName}</strong>? They will be unable to login until unlocked.
        </Typography>
        <TextField
          fullWidth
          label="Reason (Optional)"
          placeholder="e.g., Suspicious activity detected"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          rows={3}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} disabled={loading} sx={{ color: 'text.secondary' }}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={loading}
          sx={{
            bgcolor: '#000',
            '&:hover': { bgcolor: '#333' },
            minWidth: 100,
          }}
        >
          {loading ? <CircularProgress size={20} /> : 'Lock User'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
